import angular from 'angular';

const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['object', '$uibModalInstance', '$filter'],
    required: []
};


export class IbModalErrorSeatsSelection implements angular.IController {

    model: any;


    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $filter: any) {
        this.model = object;
    }

    $onInit (): void {
        this.getSeatsEnum();
    }

    getSeatsEnum (): void {
        this.model.segments.forEach((segment: any) => {
            if(segment.seats.length === 1) {
                segment.seatsFormatted = this.$filter('translate')('NEW_SEATS_MAP_SEATS_SELECTION_ERROR_SEAT').replace('#', segment.seats[0]);
            } else {
                const lastIndex: number = segment.seats.length - 1;
                let seatsFormatted: string = '';
                segment.seats.forEach((seat: string, index: number) => {
                    if(index === 0) {
                        seatsFormatted += seat;
                    } else if(index === lastIndex) {
                        seatsFormatted += this.$filter('translate')('NEW_SEATS_MAP_SEATS_SELECTION_ERROR_AND').replace('#', seat);
                    } else {
                        seatsFormatted += ', ' + seat;
                    }
                });
                segment.seatsFormatted =  this.$filter('translate')('NEW_SEATS_MAP_SEATS_SELECTION_ERROR_SEATS') + seatsFormatted;
            }
            segment.originDestination = segment.originDestination.concat(segment.seatsFormatted.slice(0, 1));
            segment.seatsFormatted = segment.seatsFormatted.slice(2, segment.seatsFormatted.length);
        });
    }

    accept (): void {
        this.$uibModalInstance.close();
    }

    close (): void {
        this.$uibModalInstance.dismiss();
    }
}

try {
    IbModalErrorSeatsSelection.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(IbModalErrorSeatsSelection.name, IbModalErrorSeatsSelection);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    IbModalErrorSeatsSelection.$inject = controllerInfo.inject;
    mod.controller(IbModalErrorSeatsSelection.name, IbModalErrorSeatsSelection);
}